'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _reactLoader = require('react-loader');

var _reactLoader2 = _interopRequireDefault(_reactLoader);

var _reactSlidedown = require('react-slidedown');

var _search = require('redux/modules/search');

var searchActions = _interopRequireWildcard(_search);

var _ = require('../');

var _ScreenedCompaniesList = require('./ScreenedCompaniesList.css');

var _ScreenedCompaniesList2 = _interopRequireDefault(_ScreenedCompaniesList);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ScreenedCompaniesList = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    results: state.company.result,
    searching: state.company.loading,
    searched: state.company.loaded,
    error: state.company.error
  };
}, searchActions), _dec2 = (0, _reactCssModules2.default)(_ScreenedCompaniesList2.default, { allowMultiple: true }), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(ScreenedCompaniesList, _Component);

  function ScreenedCompaniesList(props) {
    (0, _classCallCheck3.default)(this, ScreenedCompaniesList);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ScreenedCompaniesList.__proto__ || (0, _getPrototypeOf2.default)(ScreenedCompaniesList)).call(this, props));

    _this.clickViewMore = function () {
      if (_this.state[_this.props.screen].length <= 0) {
        _this.props.companies(_this.props.screen);
      }
      var newState = {};
      newState['viewMore_' + _this.props.screen] = !_this.state['viewMore_' + _this.props.screen];
      _this.setState(newState);
    };

    _this.state = {
      viewMore_is_co: false,
      viewMore_is_og: false,
      viewMore_is_f15: false,
      viewMore_is_ut: false,
      viewMore_is_fossil_bank: false,
      viewMore_is_fossil_insure: false,
      viewMore_is_po_producer: false,
      viewMore_is_po_financier: false,
      viewMore_is_po_consumer: false,
      viewMore_is_gm: false,
      viewMore_is_gr: false,
      viewMore_is_pp: false,
      viewMore_is_borders: false,
      viewMore_is_pff_high: false,
      viewMore_is_pff_extreme: false,
      viewMore_is_mmc: false,
      viewMore_is_nw: false,
      viewMore_is_cm: false,
      viewMore_is_to: false,
      viewMore_is_tm: false,
      is_co: [],
      is_og: [],
      is_f15: [],
      is_ut: [],
      is_fossil_bank: [],
      is_fossil_insure: [],
      is_po_producer: [],
      is_po_financier: [],
      is_po_consumer: [],
      is_gm: [],
      is_gr: [],
      is_pp: [],
      is_borders: [],
      is_pff_high: [],
      is_pff_extreme: [],
      is_mmc: [],
      is_nw: [],
      is_cm: [],
      is_to: [],
      is_tm: []
    };
    return _this;
  }

  (0, _createClass3.default)(ScreenedCompaniesList, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      if (props.results && props.results.result) {
        var companies = [];
        props.results.result.map(function (el) {
          if (el[props.screen]) companies.push(el);
          return false;
        });
        if (companies.length <= 0) {
          return;
        }
        var _sorter = function _sorter(a, b) {
          var lbl = 'short_name';
          var a_s = a[lbl].toLowerCase();
          var b_s = b[lbl].toLowerCase();
          return a_s.localeCompare(b_s);
        };
        var newState = {};
        newState[props.screen] = companies.sort(_sorter);
        // console.log('\n\n\nlorem here newState')
        // console.log(newState)
        // console.log('lorem here this.state')
        // console.log(this.state)
        // console.log('lorem here this.props.screen')
        // console.log(this.props.screen)
        this.setState(newState);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var label = !this.state['viewMore_' + this.props.screen] ? 'View companies' : 'View less';

      return _react2.default.createElement(
        'div',
        { styleName: 'main-wrap' },
        _react2.default.createElement(
          'div',
          { styleName: 'company-table-wrapper' },
          _react2.default.createElement(
            'button',
            {
              styleName: 'company-table-button',
              onClick: this.clickViewMore,
              title: label
            },
            label,
            _react2.default.createElement(_.LinkIcon, {
              faclass: this.state['viewMore_' + this.props.screen] ? 'fa-angle-up' : 'fa-angle-down'
            })
          ),
          _react2.default.createElement(
            _reactSlidedown.SlideDown,
            null,
            this.state['viewMore_' + this.props.screen] ? _react2.default.createElement(
              'div',
              null,
              this.state[this.props.screen] && this.state[this.props.screen].length > 0 ? _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'div',
                  { styleName: 'table-count' },
                  this.state[this.props.screen].length.toLocaleString(),
                  ' companies flagged'
                ),
                _react2.default.createElement(
                  'table',
                  { styleName: 't-table' },
                  _react2.default.createElement(
                    'thead',
                    null,
                    _react2.default.createElement(
                      'tr',
                      null,
                      _react2.default.createElement(
                        'th',
                        null,
                        'Company'
                      ),
                      _react2.default.createElement(
                        'th',
                        null,
                        'Symbol'
                      ),
                      _react2.default.createElement(
                        'th',
                        null,
                        'Legal name'
                      )
                    )
                  ),
                  _react2.default.createElement(
                    'tbody',
                    null,
                    this.state[this.props.screen].map(function (c, i) {
                      return _react2.default.createElement(
                        'tr',
                        { key: 'to_' + i },
                        _react2.default.createElement(
                          'td',
                          null,
                          c.short_name
                        ),
                        _react2.default.createElement(
                          'td',
                          null,
                          c.primary_symbol
                        ),
                        _react2.default.createElement(
                          'td',
                          null,
                          c.legal_name
                        )
                      );
                    })
                  )
                )
              ) : _react2.default.createElement(
                'div',
                { styleName: 'main' },
                _react2.default.createElement(_reactLoader2.default, {
                  options: { scale: 0.70, top: '4.0rem' },
                  loaded: false
                })
              )
            ) : null
          )
        )
      );
    }
  }]);
  return ScreenedCompaniesList;
}(_react.Component), _class2.propTypes = {
  searching: _react.PropTypes.bool,
  searched: _react.PropTypes.bool,
  error: _react.PropTypes.object,
  results: _react.PropTypes.object
}, _temp)) || _class) || _class);
exports.default = ScreenedCompaniesList;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ScreenedCompaniesList/ScreenedCompaniesList.js
// module id = 1439
// module chunks = 0